import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { TurumbaAdminLayoutComponent } from './layouts/turumba-admin-layout/turumba-admin-layout.component';
import { TurumbaAuthLayoutComponent } from './layouts/turumba-auth-layout/turumba-auth-layout.component';
import {HttpClientModule} from '@angular/common/http';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import { HighlightDirective } from './admin-pages/chat-conversation/directive/highlight.directive';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    TurumbaAdminLayoutComponent,
    TurumbaAuthLayoutComponent,
    HighlightDirective,
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
  exports: [
    HighlightDirective
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
